//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    height: {
      type: String,
      default: '600px'
    },
    hascountdown: {
      type: String,
      default: ''
    }
  },
  mounted () {
    let count = 5
    this.timer = setInterval(() => {
      const txt = this.$v('{0}秒后返回首页').replace('{0}', (count < 0 ? 0 : count))
      this.$refs.cutdownMsg.innerText = txt
      if (count <= 0) {
        this.tolink()
      }
      count--
    }, 1000)
  },
  methods: {
    tolink () { // 跳转
      window.location.href = `/${this.$store.state.LanguageCode}/`
    }
  }
}
